import { Button, Flex, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReasonSelect } from 'src/components/v1/Select';
import { OpenNoteType, ProcessType } from 'src/components/v2/Button/BtnHandleList';

const { Text } = Typography;

interface Props {
  open: OpenNoteType;
  setOpen: React.Dispatch<React.SetStateAction<OpenNoteType>>;
  handleAddRejectNote: (reasonId?: number, noteReject?: string, processType?: ProcessType) => void;
}

interface FormStateType {
  reasonId?: number;
  noteReject?: string;
}

const initFormState: FormStateType = {
  reasonId: undefined,
  noteReject: ''
};

export default function AddRejectNote({ open, setOpen, handleAddRejectNote }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState<FormStateType>(initFormState);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleAddRejectNote(formState.reasonId, formState.noteReject, open.processType);
        setOpen({ isOpen: false });
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen({ isOpen: false });
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Lý do từ chối</Text>
          <Text type='danger'>*</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open.isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='cancel' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form
        form={form}
        layout='vertical'
        fields={[
          {
            name: 'reasonId',
            value: formState?.reasonId
          },
          {
            name: 'noteReject',
            value: formState?.noteReject
          }
        ]}
      >
        <Form.Item
          label={t('columnTitle.ticket.reason')}
          name='reasonId'
          rules={[{ required: true, message: t('required.ticket.reason').toString() }]}
        >
          <ReasonSelect onChange={(value) => setFormState((prev) => ({ ...prev, reasonId: value }))} />
        </Form.Item>
        <Form.Item label={t('columnTitle.ticket.noteReject')} name='noteReject'>
          <TextArea
            placeholder={t('placeholder.ticket.noteReject').toString()}
            onChange={(e) => setFormState((prev) => ({ ...prev, noteReject: e.target.value }))}
            rows={2}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
